/* Custom overrides - Chaps London
   Adds swipe dots to the footer USP row on mobile. The scrolling and snapping
   itself is pure CSS (see custom-overrides.css); this only draws the dots and
   keeps them in sync. Safe to delete along with its tag in layout/theme.liquid. */
(function () {
  var MOBILE = '(max-width: 767.98px)';

  function buildDots(track) {
    var slides = Array.prototype.filter.call(track.children, function (el) {
      return el.classList.contains('column');
    });
    if (slides.length < 2) return;

    var dots = document.createElement('div');
    dots.className = 'usp-carousel__dots';

    var buttons = slides.map(function (slide, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'usp-carousel__dot' + (i === 0 ? ' usp-carousel__dot--active' : '');
      b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
      b.addEventListener('click', function () {
        track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      });
      dots.appendChild(b);
      return b;
    });

    track.parentNode.insertBefore(dots, track.nextSibling);

    var raf = null;
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = window.requestAnimationFrame(function () {
        raf = null;
        var width = track.clientWidth || 1;
        var index = Math.round(track.scrollLeft / width);
        if (index < 0) index = 0;
        if (index > buttons.length - 1) index = buttons.length - 1;
        buttons.forEach(function (b, i) {
          b.classList.toggle('usp-carousel__dot--active', i === index);
        });
      });
    }, { passive: true });
  }

  function init() {
    if (!window.matchMedia(MOBILE).matches) return;
    var tracks = document.querySelectorAll('.cross-page-promos .flexible-layout');
    Array.prototype.forEach.call(tracks, function (track) {
      if (track.dataset.uspCarousel) return;
      track.dataset.uspCarousel = 'true';
      buildDots(track);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Run again if the viewport crosses into mobile, or the section reloads in the editor.
  window.addEventListener('resize', init, { passive: true });
  document.addEventListener('shopify:section:load', init);
})();
